import { VARIANT_CODE as CRITERIA_TYPE } from '../constants/criteria.variants'
import { MEASURE_UNIT } from '../constants/measurePeriodUnits.values'
import { VARIANT_CODE as CRITERIA_ELEMENT_TYPE } from '../constants/criteriaElement.variants'

const createItem = (name, type, description, unit, criteria) => ({
	name, type, description, unit, criteria
})

const createCriteria2 = (min, max, points) => ({min, max, points, variant: CRITERIA_ELEMENT_TYPE.RANGE})
const createCriteriaSmaller = (max, points) => ({max, points, variant: CRITERIA_ELEMENT_TYPE.SMALLER})
const createCriteriaBigger = (min, points) => ({min, points, variant: CRITERIA_ELEMENT_TYPE.BIGGER})
const createCriteriaL = (units, points) => ({units, points})

export default [
	createItem('NAME 1', CRITERIA_TYPE.INTERVAL, 'DESCRIPTION 1', MEASURE_UNIT.MONTH, [
		createCriteriaBigger(2, 20),
		createCriteria2(3, 13, 10),
		createCriteriaSmaller(1, 25),
		createCriteriaBigger(4, 35),
		createCriteria2(1, 7, 30),
	]),
	createItem('NAME 2', CRITERIA_TYPE.LIST, 'DESCRIPTION 2', MEASURE_UNIT.WEEKS, [
		createCriteriaL(3,11),
		createCriteriaL(1,21),
		createCriteriaL(7,41),
		createCriteriaL(2,12),
		createCriteriaL(3,26),
		createCriteriaL(2,12),
	]),
	createItem('Lorem ipsum dolor sit amet consectetur', CRITERIA_TYPE.INTERVAL, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut in mi facilisis, iaculis diam ut, lobortis dolor. Morbi venenatis elementum condimentum. Donec commodo quam eget ipsum venenatis, vitae mollis turpis volutpat. Etiam sit amet ullamcorper tortor. Nulla et feugiat massa.', MEASURE_UNIT.DAY, [
		createCriteria2(3, 13, 10),
		createCriteriaSmaller(1, 25),
		createCriteriaBigger(2, 20),
		createCriteria2(1, 7, 30),
		createCriteriaBigger(4, 35),
	]),
]